export default "__VITE_ASSET__BVQtOd9l__"